import { Link } from 'react-router-dom'
import styled from 'styled-components'

function Error() {
    return (
        <ErrorContainer>
            <PageNotFound>Page Not found</PageNotFound>
            <Link to="/">Go to Home</Link>
        </ErrorContainer>
    )
}

const ErrorContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 150px;
`

const PageNotFound = styled.h4`
    color: #333;
    margin: 20px 0;
    font-size: 20px;
`

export default Error
